<div style="height: 100%; background-color: transparent; color: #3d3d3d; padding-top: 10px; padding-left: 70px; padding-right: 70px; padding-bottom: 10px;">
    <div class="row">
        <div class="col">
            <hr>
        </div>
        <div class="col" align="center">
            <span>&copy; 2024 CompData IT GmbH </span>
        </div>
        <div class="col">
            <hr>
        </div>
    </div>
</div>